export const userEvents = {
  licenseCreateClick: { evid: 712 },
  licenseUpload: { evid: 713 },
  licenseNewLicenseSave: { evid: 714 },
  licenseEdit: { evid: 715 },
  licenseDelete: { evid: 716 },
  licenseChangeCurrencyClick: { evid: 717 },
  licenseQualityToggle: { evid: 718 },
  licenseToggle: { evid: 719 },
  licenseQualityPrice: { evid: 720 },
  licenseSave: { evid: 721 },
  manageBusinessInfo: { evid: 722 },
  manageEmailSettings: { evid: 723 },
  manageAddLogo: { evid: 724 },
  manageLocale: { evid: 725 },
  manageLoad: { evid: 726 },
  navigation: { evid: 732 }, // http://bo.wix.com/bi-catalog-webapp/#/sources/65/events/732?artifactId=wix.photo.users.artifact.id
}
export const uouEvents = {
  buySelectLicense: { evid: 801 },
  addToCart: { evid: 802 },
  cartCheckout: { evid: 803 },
  downloadImage: { evid: 805 },
}

const addToAllKeys = (obj, key, val) => {
  Object.keys(obj).forEach(k => obj[k][key] = val)
}

addToAllKeys(userEvents, 'type', 'userEvent')
addToAllKeys(uouEvents, 'type', 'uouEvent')
